
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10014_27846)"}},[_c('path',{attrs:{"d":"M.582 6.939L11.5 11.892a1.2 1.2 0 00.998 0L23.418 6.94c.776-.352.776-1.525 0-1.877L12.499.11a1.2 1.2 0 00-.998 0L.581 5.062c-.775.352-.775 1.525 0 1.877zm22.836 4.138l-2.723-1.234-7.576 3.434a2.69 2.69 0 01-2.237 0L3.305 9.843.582 11.077c-.776.351-.776 1.523 0 1.875l10.919 4.95c.319.144.68.144.998 0l10.92-4.95c.775-.352.775-1.524 0-1.875zm0 5.99l-2.712-1.229-7.587 3.44a2.69 2.69 0 01-2.237 0l-7.587-3.44-2.713 1.23c-.776.351-.776 1.523 0 1.874l10.919 4.95c.319.145.68.145.998 0l10.92-4.95c.775-.351.775-1.523 0-1.875z","fill":"#910000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10014_27846"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    